module.exports = __webpack_public_path__ + "img/security-audit-img-2.6edaedaa.png";